export const getAspectRatio = (imageWidth, imageHeight) => (imageHeight / imageWidth)

export const getImageWidth = (vw, colSpan) => {
  const co = vw / 24

  if (window.matchMedia) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      /* the viewport is mobile */
      const mobileColSpan = 20
      return mobileColSpan * co
    }
  }

  return colSpan * co
}

export const getImageHeight = (width, aspectRatio) => {
  return width * aspectRatio
}

export const getPositionStyle = (vw, xOffset, yOffset, colSpan) => {
  const co = vw / 24 // 100%(viewportwidth) / 24 * NUM_OF_COLS 
  let xOffsetVw = xOffset * co
  let yOffsetVw = yOffset * co
  let widthVw = colSpan * co

  if (window.matchMedia) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      /* the viewport is mobile */
      const mobileXOffset = 2
      const mobileYOffset = 0
      const mobileColSpan = 20

      xOffsetVw = mobileXOffset * co
      yOffsetVw = mobileYOffset * co
      widthVw = mobileColSpan * co

      return {
        margin: 0,
        width: `${widthVw}px`,
        left: `${xOffsetVw}px`,
        [yOffsetVw < 0 ? 'top' : 'paddingTop']: `${yOffsetVw}px`
      }
    }
  }

  return {
    margin: 0,
    width: `${widthVw}px`,
    left: `${xOffsetVw}px`,
    [yOffsetVw < 0 ? 'top' : 'paddingTop']: `${yOffsetVw}px`
  }
}

export const getAspectRatioStyle = (vw, colSpan, aspectRatio) => {
  return { 
    width: getImageWidth(vw, colSpan),
    height: getImageHeight(getImageWidth(vw, colSpan), aspectRatio)
  }
}


// WEBPACK FOOTER //
// ./src/lib/gridUtil.js